import { Loader } from '@nordlayer/rivendell-ui';
import loadable from '@nordvpn/teams.core/lib/tools/loadable';
import { RouteGenerator } from 'routing/RouteGenerator';
import { PermissionsEnum } from 'types/permissions/enums';
import { ACTIVITY_LIST_PATH } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
var ActivityListOld = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/ActivityListOld');
});
var ActivityList = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/ActivityList');
});
export var ActivityRouting = function ActivityRouting(_ref) {
    var areFeaturesLoaded = _ref.areFeaturesLoaded, isActivityRedesignEnabled = _ref.isActivityRedesignEnabled;
    var getListPage = function getListPage() {
        if (!areFeaturesLoaded) {
            return /*#__PURE__*/ _jsx(Loader, {
                centered: true
            });
        }
        return isActivityRedesignEnabled ? /*#__PURE__*/ _jsx(ActivityList, {}) : /*#__PURE__*/ _jsx(ActivityListOld, {});
    };
    return RouteGenerator({
        actions: {
            path: ACTIVITY_LIST_PATH,
            component: function component() {
                return getListPage();
            },
            permission: PermissionsEnum.ViewActivityLog,
            exact: true
        }
    });
};
